import { writeContractWithErrorHandling } from './util'

export const payDividendFromEntity = writeContractWithErrorHandling(
  (guid, amount, contract) => contract.payDividendFromEntity(guid, amount)
)
